import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-wijk-speelplaats',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconWijkSpeelplaats {

  render() {
    return (
      <svg data-name="Layer 1" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M23.5 14.02c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5-3.5 1.57-3.5 3.5 1.57 3.5 3.5 3.5m0-5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5M21 21.01c-.55 0-1-.45-1-1v-1c0-2.21 1.79-4 4-4h2c2.76 0 4-2.24 4-5 0-.55.45-1 1-1s1 .45 1 1c0 3.52-1.61 6.43-5 6.92v8.08c0 .55-.45 1-1 1s-1-.45-1-1v-8h-1c-1.1 0-2 .9-2 2v1c0 .55-.45 1-1 1m14 13h-2.47c-.74 0-1.45-.32-1.94-.76L15 17.43V6.92c0-.57-.24-1.11-.66-1.49L8.77.45C8.04-.14 7-.14 6.27.45L.67 5.43c-.42.38-.67.93-.67 1.5v28.08c0 .55.45 1 1 1s1-.45 1-1V20.02h11v14.99c0 .55.45 1 1 1s1-.45 1-1V20.17l13.88 14.29c1.1 1 2.53 1.55 4.02 1.55H35c.55 0 1-.45 1-1s-.45-1-1-1M13 18.02H2V6.99l5.52-4.98L13 6.98zm-9-7.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5S4 8.59 4 10.52m5 0c0 .83-.67 1.5-1.5 1.5S6 11.35 6 10.52s.67-1.5 1.5-1.5 1.5.67 1.5 1.5"/>
</svg>

    );
  }
}
